import { render, staticRenderFns } from "./CategorySorts.vue?vue&type=template&id=b179bcb6&scoped=true&name=the-sorts&"
import script from "./CategorySorts.vue?vue&type=script&lang=js&"
export * from "./CategorySorts.vue?vue&type=script&lang=js&"
import style0 from "./CategorySorts.vue?vue&type=style&index=0&id=b179bcb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b179bcb6",
  null
  
)

/* custom blocks */
import block0 from "./CategorySorts.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports